import { clsx } from 'clsx/lite';
import styles from './BorderlessPanel.module.css';

interface BorderlessPanelProps {
  className?: string;
  headerClassName?: string;
  contentsClassName?: string;
  tabsClassname?: string;
  children?: React.ReactNode;
  headerContents?: React.ReactNode;
  tabs?: React.ReactNode;
}

// TODO: Consider always requiring a class name for contents or providing default sets of padding/sizing?

const BorderlessPanel: React.FC<BorderlessPanelProps> = ({
  className,
  children,
  headerContents,
  headerClassName,
  contentsClassName,
  tabs,
  tabsClassname,
}) => (
  <div className={clsx(styles.wrapper, className)}>
    <div className={clsx(styles.header, headerClassName)}>{headerContents}</div>
    {tabs && <div className={clsx(styles.tabs, tabsClassname)}>{tabs}</div>}
    <div className={clsx(styles.contents, contentsClassName)}>{children}</div>
  </div>
);

export default BorderlessPanel;
